export default __webpack_public_path__ + "static/collaborate_react-7280a6e034706d69d5f597e7b16d8b28.webp";